import React, { useRef } from "react";
import i2 from '../../../assets/j1.png';
// import { Input } from "@mui/material";
import FileUpload from "../../FileUpload";

const JobCTA = () => {
    const fileInputRef = useRef(null);

    // const handleButtonClick = () => {
    //     fileInputRef.current.click();
    // };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            alert(`You selected: ${file.name}`);
        }
    };

    return (
        <section className="flex items-center justify-center bg-gradient-to-b from-gray-100 to-white">
            <div className="flex flex-col md:flex-row bg-[#B9313A] text-white md:rounded-lg shadow-lg py-8 px-4 md:px-12 md:max-w-[1100px]  m-auto">
                <div className="flex-1 flex justify-center items-center mb-2 md:mb-0">
                    <img
                        src={i2}
                        alt="Person Pointing"
                        className="md:w-[380px] w-[250px] h-auto rounded-xl"
                    />
                </div>

                <div className="flex-1">
                    <h1 className="text-2xl md:text-4xl font-bold mb-4 md:leading-tight md:mt-14">
                        Get Matched The Most Valuable Jobs, Just{" "}
                        <span className="underline font-semibold">Drop Your CV</span> at
                        Jinrai Technologies
                    </h1>
                    <p className="text-gray-200 mb-6 text-sm leading-relaxed">
                        To apply, please email your updated CV to contact@jinraitech.com or drop your CV below.
                    </p>

                    <button
                        data-modal-target="crud-modal" data-modal-toggle="crud-modal"
                        className="flex items-center justify-center gap-2 bg-white border-2 border-white text-[#B9313A] font-semibold px-6 py-2 shadow-md hover:bg-[#B9313A] hover:text-white transition duration-300"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M4 16v3a1 1 0 001 1h14a1 1 0 001-1v-3m-4-4l-4-4m0 0l-4 4m4-4v12"
                            />
                        </svg>
                        Upload Your CV
                    </button>
                    {/* <div id="crud-modal" tabindex="-1" aria-hidden="true" class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
                        <div class="relative p-4 w-full max-w-md max-h-full">

                            <div class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">

                                <div class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                                    <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
                                        Upload CV
                                    </h3>
                                    <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white" data-modal-toggle="crud-modal">
                                        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                        </svg>
                                        <span class="sr-only">Close modal</span>
                                    </button>
                                </div>

                                <form class="p-4 md:p-5">
                                    <div class="grid gap-4 mb-4 sm:grid-cols-2 w-full">
                                        <div class="w-full">
                                            <label for="name" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Name</label>
                                            <input type="text" name="name" id="name" class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Type product name" required="" />
                                        </div>

                                        <div class="w-full">
                                            <label for="phone" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Phone Number</label>
                                            <input type="number" name="phone" id="phone" class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="Enter phone number" required="" />
                                        </div>

                                        <div class="sm:col-span-2 w-full">
                                            <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email</label>
                                            <input type="text" name="email" id="email" class="w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500" placeholder="abc@gmail.com" required="" />
                                        </div>
                                    </div>

                             <FileUpload/>
                                    <button type="submit" class="text-white inline-flex items-center bg-[#B9313A] hover:bg-[#B9313A] focus:ring-4  font-medium rounded-lg text-sm px-5 py-2.5 text-center mt-4">
                                        Submit
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div> */}
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        accept=".pdf,.doc,.docx"
                        className="hidden"
                    />
                </div>
            </div>
        </section>
    );
};

export default JobCTA;
